import React from "react";
import { useParams } from "react-router-dom";
import MatchDetail from "./MatchDetail";
import PrematchDetail from "./PrematchDetail";

// FootyStats prematch fixtures use the "fs:" namespace (e.g. fs:8409639) and
// must NOT hit the LIVE live-center path. Numeric/live fixture ids keep the
// existing live MatchDetail unchanged. Only one component mounts, so fs:*
// fixtures never trigger a live-center request.
export default function MatchRoute() {
  const { id = "" } = useParams();
  return id.startsWith("fs:") ? <PrematchDetail /> : <MatchDetail />;
}
